import api from './api'
export default {
    post: function(parms) {
      return api.post('tour-update',parms)
    }
    
}